import { Component } from 'react';
import { connect } from 'react-redux';
import ExecutionEnvironment from 'exenv';

import { HYDRA_PERSONALIZATION_MARKER } from 'constants/hydraTests';
import { evRecommendationClick } from 'events/recommendations';
import { makePersonalizationMarker } from 'helpers/PersonalizationUtils';
import { getAssignmentGroup, triggerAssignment } from 'actions/ab';
import { track } from 'apis/amethyst';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardCategory from 'components/common/melodyCard/MelodyCardCategory';
import marketplace from 'cfg/marketplace.json';
import PersonalizationMarker from 'components/landing/PersonalizationMarker';

import css from 'styles/components/landing/melodyPersonalizedBrand.scss';

const widgetType = 'BRAND_RECOMMENDATION_WIDGET';
const recommendationSource = 'ZAPPOS_DATA_SCIENCE';
const recommendationType = 'BRAND_RECOMMENDATION';

export class MelodyPersonalizedBrand extends Component {
  componentDidMount() {
    const { triggerAssignment } = this.props;
    triggerAssignment(HYDRA_PERSONALIZATION_MARKER);
  }

  handleClick = (e, index, id) => {
    const { onLandingComponentClick } = this.props;
    onLandingComponentClick(e);
    track(evRecommendationClick, {
      index,
      recommendationType,
      recommendationValue: id,
      recommendationSource,
      widgetType
    });
  };

  makeHeadingText = isTrending => {
    const { firstName } = this.props;
    if (isTrending) {
      return 'Trending Brands';
    }
    return firstName ?
      `${firstName}, You Might Like These Brands` :
      'Brands For You';
  };

  render() {
    const {
      slotName,
      slotDetails: { brands, monetateId },
      shouldLazyLoad,
      isCustomer,
      location,
      hydraPersonalizationMarker
    } = this.props;
    const { desktopBaseUrl } = marketplace;

    if (brands && brands.length) {
      const recoSource = brands[0].recommendationSource;
      const isTrending = recoSource && recoSource === 'TRENDING_BRANDS';
      const isPersonalized = !isTrending;
      return (
        <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
          <h2 className={css.heading}>
            {this.makeHeadingText(isTrending)}
            {makePersonalizationMarker({
              PersonalizationMarker,
              isCustomerRecognized: isCustomer,
              isPersonalized,
              componentName: 'MelodyPersonalizedBrand',
              sourcePage: 'LANDING_PAGE',
              location
            }, hydraPersonalizationMarker)}
          </h2>
          <MelodyCarousel>
            {brands.map((brand, index) => {
              const { headerImageUrl, name, cleanName, id, brandUrl } = brand;
              const link = brandUrl || `/search/null/filter/brandNameFacet/${encodeURIComponent(name)}`;
              const cardData = {
                image: `${desktopBaseUrl}${headerImageUrl}`,
                name,
                alt: name,
                gae: cleanName,
                link
              };
              return <MelodyCardCategory
                cardData={cardData}
                eventLabel="melodyPersonalizedBrand"
                melodyCardTestId="melodyPersonalizedBrand"
                onLandingComponentClick={e => {
                  this.handleClick(e, index, id);
                }}
                shouldLazyLoad={shouldLazyLoad}
                key={id} />;
            })}
          </MelodyCarousel>
        </div>
      );
    }
    return false;
  }
}

function mapStateToProps(state) {
  const location = ExecutionEnvironment.canUseDOM ? window.location : state.routing.locationBeforeTransitions || {};
  return {
    firstName: state.holmes.firstName,
    isCustomer: !!state.cookies['x-main'],
    hydraPersonalizationMarker: getAssignmentGroup(HYDRA_PERSONALIZATION_MARKER, state),
    triggerAssignment,
    location
  };
}

export default connect(mapStateToProps, {
})(MelodyPersonalizedBrand);
